const DriverRelationValues = {
    SPOUSE: 'S',
    PARENT: 'P',
    CHILD: 'C',
    SIBLING: 'B',
    OTHER_RELATIVE: 'R',
    COHABITANT: 'H',
    EMPLOYEE: 'E',
    OTHER: 'O',
    PRIMARY: 'I',
};

export default DriverRelationValues;
